/**
 * Colour picker drawer (#ColourDrawer, snippets/drawer-colour.liquid).
 *
 * The colour swatches in product-template.liquid are plain links to each
 * colour's product page. This intercepts clicks on them and opens a drawer
 * with all colours plus a size filter. Data comes from the sibling JSON in
 * [data-colour-drawer-data]:
 *   [{ handle, url, title, image, current, sizes: [{ size, id, available }] }]
 */
(function () {
  if (window.theme && theme.ColourDrawer) return;

  var drawerEl = document.getElementById('ColourDrawer');
  if (!drawerEl) return;

  var els = {
    sizes: drawerEl.querySelector('[data-colour-drawer-sizes]'),
    sizeSection: drawerEl.querySelector('[data-colour-drawer-size-section]'),
    sizeArrows: drawerEl.querySelectorAll('[data-colour-drawer-sizes-arrow]'),
    grid: drawerEl.querySelector('[data-colour-drawer-grid]'),
    name: drawerEl.querySelector('[data-colour-drawer-name]'),
    cta: drawerEl.querySelector('[data-colour-drawer-cta]')
  };
  var allSizesLabel = els.sizes.querySelector('[data-size=""]').textContent;
  var strings = {
    select: drawerEl.dataset.stringSelect,
    selectNamed: drawerEl.dataset.stringSelectNamed,
    soldOut: drawerEl.dataset.stringSoldOut
  };

  var drawer = null;
  var state = {
    products: [],
    sizes: [],
    selectedHandle: null,
    selectedSize: ''
  };

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /**
   * Titles have no colour field, e.g. "Hoka M CLIFTON 11 Black / White".
   * Strip the word prefix every sibling shares to get the colour part, backing
   * off so the prefix never cuts into a "X / Y" colour or empties a title.
   */
  function addColourNames(products) {
    var words = products.map(function (p) { return p.title.trim().split(/\s+/); });
    var prefixLength = 0;

    if (products.length > 1) {
      var shortest = Math.min.apply(null, words.map(function (w) { return w.length; }));
      while (
        prefixLength < shortest &&
        words.every(function (w) { return w[prefixLength] === words[0][prefixLength]; })
      ) {
        prefixLength++;
      }

      var cutsIntoColour = function () {
        return words.some(function (w) {
          return (
            w.length <= prefixLength ||
            w.slice(0, prefixLength).indexOf('/') !== -1 ||
            w[prefixLength] === '/'
          );
        });
      };
      while (prefixLength > 0 && cutsIntoColour()) {
        prefixLength--;
      }
    }

    products.forEach(function (p, i) {
      p.colourName = words[i].slice(prefixLength).join(' ') || p.title;
    });
  }

  // Current product's size order first, then any sizes only other colours have.
  function collectSizes(products) {
    var ordered = products.slice().sort(function (a, b) {
      return (b.current ? 1 : 0) - (a.current ? 1 : 0);
    });
    var sizes = [];
    ordered.forEach(function (p) {
      p.sizes.forEach(function (s) {
        if (s.size && sizes.indexOf(s.size) === -1) sizes.push(s.size);
      });
    });
    return sizes;
  }

  // Products are single-option (Size) today; with more options the first
  // variant for a size wins.
  function variantFor(product, size) {
    for (var i = 0; i < product.sizes.length; i++) {
      if (product.sizes[i].size === size) return product.sizes[i];
    }
    return null;
  }

  function isAvailable(product, size) {
    if (!size) {
      return product.sizes.some(function (s) { return s.available; });
    }
    var variant = variantFor(product, size);
    return !!(variant && variant.available);
  }

  function selectedProduct() {
    for (var i = 0; i < state.products.length; i++) {
      if (state.products[i].handle === state.selectedHandle) return state.products[i];
    }
    return null;
  }

  function renderSizes() {
    // A single size (e.g. "OneSize") makes the filter pointless.
    els.sizeSection.hidden = state.sizes.length < 2;

    var html = [''].concat(state.sizes).map(function (size) {
      var active = size === state.selectedSize;
      var inStock = !size || state.products.some(function (p) { return isAvailable(p, size); });
      return (
        '<button type="button" class="colour-drawer__size' +
        (active ? ' is-active' : '') +
        (inStock ? '' : ' is-unavailable') +
        '" data-size="' + escapeHtml(size) + '" aria-pressed="' + active + '">' +
        escapeHtml(size || allSizesLabel) +
        '</button>'
      );
    });
    // The row scrolls sideways; keep its position across re-renders.
    var scrollLeft = els.sizes.scrollLeft;
    els.sizes.innerHTML = html.join('');
    els.sizes.scrollLeft = scrollLeft;
    updateSizeArrows();
  }

  // Show each arrow only while there is more of the row to scroll that way.
  function updateSizeArrows() {
    var max = els.sizes.scrollWidth - els.sizes.clientWidth;
    els.sizeArrows.forEach(function (arrow) {
      var forward = arrow.dataset.colourDrawerSizesArrow === '1';
      arrow.hidden = forward ? els.sizes.scrollLeft >= max - 1 : els.sizes.scrollLeft <= 1;
    });
  }

  function renderGrid() {
    var size = state.selectedSize;
    els.grid.innerHTML = state.products.map(function (p) {
      var available = isAvailable(p, size);
      // With a size picked, colours without it in stock can't be chosen.
      // With "all", fully sold-out colours are only dimmed.
      var disabled = !!size && !available;
      var selected = p.handle === state.selectedHandle;
      return (
        '<button type="button" class="colour-drawer__swatch' +
        (selected ? ' is-selected' : '') +
        (available ? '' : ' is-unavailable') +
        '" data-handle="' + escapeHtml(p.handle) + '"' +
        ' aria-label="' + escapeHtml(p.colourName) + '" title="' + escapeHtml(p.colourName) + '"' +
        ' aria-pressed="' + selected + '"' +
        (disabled ? ' disabled' : '') + '>' +
        '<span class="colour-drawer__swatch-image">' +
        '<img src="' + escapeHtml(p.image) + '" alt="" loading="lazy" width="200" height="200">' +
        (available ? '' : '<span class="colour-drawer__swatch-badge">' + escapeHtml(strings.soldOut) + '</span>') +
        '</span>' +
        '</button>'
      );
    }).join('');
  }

  function renderSelection() {
    var product = selectedProduct();
    els.name.textContent = product ? product.colourName : '';

    if (!product) {
      els.cta.textContent = strings.select;
      els.cta.setAttribute('href', '#');
      els.cta.classList.add('disabled');
      els.cta.setAttribute('aria-disabled', 'true');
      return;
    }

    var url = product.url;
    var variant = state.selectedSize ? variantFor(product, state.selectedSize) : null;
    if (variant) url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variant.id;

    els.cta.textContent = strings.selectNamed.replace('[colour]', product.colourName);
    els.cta.setAttribute('href', url);
    els.cta.classList.remove('disabled');
    els.cta.removeAttribute('aria-disabled');
  }

  function render() {
    renderSizes();
    renderGrid();
    renderSelection();
  }

  function open(products, handle, triggerEl) {
    addColourNames(products);
    state.products = products;
    state.sizes = collectSizes(products);
    state.selectedHandle = handle;
    state.selectedSize = '';
    els.sizes.scrollLeft = 0;
    render();

    if (!drawer) drawer = new theme.Drawers('ColourDrawer', 'colour');
    drawer.open(null, triggerEl);
    revealSelected();
    requestAnimationFrame(updateSizeArrows);
  }

  // Bring the pre-selected colour into view when it sits below the fold.
  function revealSelected() {
    var scroller = drawerEl.querySelector('.drawer__scrollable');
    var selected = els.grid.querySelector('.is-selected');
    if (!scroller || !selected) return;
    scroller.scrollTop = 0;
    requestAnimationFrame(function () {
      var overflow = selected.getBoundingClientRect().bottom - scroller.getBoundingClientRect().bottom;
      if (overflow > 0) scroller.scrollTop = overflow + 16;
    });
  }

  // Re-rendering detaches the clicked button, which theme.Drawers' outside-click
  // check would read as a click outside the drawer, so keep these off window.
  els.sizes.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-size]');
    if (!btn) return;
    evt.stopPropagation();
    state.selectedSize = btn.dataset.size;
    var product = selectedProduct();
    if (product && !isAvailable(product, state.selectedSize) && state.selectedSize) {
      state.selectedHandle = null;
    }
    render();
  });

  els.sizes.addEventListener('scroll', updateSizeArrows, { passive: true });
  window.addEventListener('resize', updateSizeArrows);

  els.sizeArrows.forEach(function (arrow) {
    arrow.addEventListener('click', function () {
      var direction = Number(arrow.dataset.colourDrawerSizesArrow);
      els.sizes.scrollBy({ left: direction * els.sizes.clientWidth * 0.7, behavior: 'smooth' });
    });
  });

  els.grid.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-handle]');
    if (!btn || btn.disabled) return;
    evt.stopPropagation();
    state.selectedHandle = btn.dataset.handle;
    renderGrid();
    renderSelection();
  });

  els.cta.addEventListener('click', function (evt) {
    var product = selectedProduct();
    if (!product) {
      evt.preventDefault();
      return;
    }
    // Already on this colour and no size to switch to: nothing to navigate to.
    if (product.current && !state.selectedSize) {
      evt.preventDefault();
      drawer.close();
    }
  });

  // Swatch links ([data-colour-drawer-trigger]) open the drawer on that colour;
  // "Vis alle farger" ([data-colour-drawer-open]) opens it on the current one.
  document.addEventListener('click', function (evt) {
    var trigger = evt.target.closest('[data-colour-drawer-trigger], [data-colour-drawer-open]');
    if (!trigger) return;
    // Let modified clicks (new tab etc.) behave as normal links.
    if (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey || evt.button !== 0) return;

    var container = trigger.closest('.product-color-variants');
    var dataEl = container && container.querySelector('[data-colour-drawer-data]');
    if (!dataEl) return;

    var products;
    try {
      products = JSON.parse(dataEl.textContent);
    } catch (err) {
      console.error('ColourDrawer: invalid colour data', err);
      return;
    }
    if (!products.length) return;

    evt.preventDefault();
    // theme.Drawers closes on any window click outside the drawer; stop this
    // one reaching window, as Drawers.open does for its own triggers.
    evt.stopPropagation();
    open(products, trigger.dataset.colourDrawerTrigger || trigger.dataset.colourDrawerOpen, trigger);
  });

  /**
   * Product page colour row ([data-colour-slider]): touch swipes natively, this
   * adds mouse drag. A drag that moved swallows the click that ends it, so it
   * doesn't open the drawer on the swatch under the pointer.
   */
  var DRAG_THRESHOLD = 5;

  function initSlider(slider) {
    if (slider.dataset.colourSliderReady) return;
    slider.dataset.colourSliderReady = 'true';

    // Start with the current colour in view.
    var selected = slider.querySelector('.--selected');
    if (selected && selected.offsetLeft + selected.offsetWidth > slider.clientWidth) {
      slider.scrollLeft = selected.offsetLeft - (slider.clientWidth - selected.offsetWidth) / 2;
    }

    var startX = 0;
    var startScroll = 0;
    var pointerId = null;
    var dragged = false;

    slider.addEventListener('pointerdown', function (evt) {
      if (evt.pointerType !== 'mouse' || evt.button !== 0) return;
      pointerId = evt.pointerId;
      startX = evt.clientX;
      startScroll = slider.scrollLeft;
      dragged = false;
    });

    slider.addEventListener('pointermove', function (evt) {
      if (evt.pointerId !== pointerId) return;
      var dx = evt.clientX - startX;
      if (!dragged && Math.abs(dx) < DRAG_THRESHOLD) return;
      if (!dragged) {
        dragged = true;
        slider.classList.add('is-dragging');
        slider.setPointerCapture(pointerId);
      }
      slider.scrollLeft = startScroll - dx;
    });

    function endDrag(evt) {
      if (evt.pointerId !== pointerId) return;
      pointerId = null;
      slider.classList.remove('is-dragging');
    }
    slider.addEventListener('pointerup', endDrag);
    slider.addEventListener('pointercancel', endDrag);

    slider.addEventListener('click', function (evt) {
      if (!dragged) return;
      dragged = false;
      evt.preventDefault();
      evt.stopPropagation();
    }, true);
  }

  function initSliders() {
    document.querySelectorAll('[data-colour-slider]').forEach(initSlider);
  }

  initSliders();
  document.addEventListener('page:loaded', initSliders);
  document.addEventListener('shopify:section:load', initSliders);

  window.theme = window.theme || {};
  theme.ColourDrawer = { open: open };
})();
